import React from "react";
import { Link } from "react-router-dom";
import ReactTooltip  from "react-tooltip";


export const TojiruX = () => {
  return (<>
    <div onClick={()=>history.back()} className="absolute top-5 right-5 cursor-pointer">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </div>
  </>
  )
}
;